export enum HeroWorkflowPersonaTabEnum {
  Developers = "developers",
  VibeCoders = "vibeCoders",
  ProductTeam = "productTeam",
}

export interface HeroWorkflowFlowNodeData extends Record<string, unknown> {
  title: string;
  description: string;
  highlight: boolean;
  accentBarClassName: string;
  cardGlowClassName: string;
}
